import { styled } from '@zoopla-eng/zds-components/themes';

export const StyledImage = styled('img', {
    width: '$sizes$L300'
});
